import { useState } from 'react';
import { Link } from 'react-router-dom';

import { api } from '../../lib/api';
import { fmtDateTime, fmtSlot } from '../../lib/format';
import type { Response } from '../../lib/types';
import { Icon } from './bits';

const KIND = {
  accept: { label: 'Aceite', icon: 'ok' },
  adjust: { label: 'Ajuste', icon: 'edit' },
  meeting: { label: 'Reunião', icon: 'cal' },
  renewal: { label: 'Renovação', icon: 'renew' },
} as const;

export const RequestItem = ({ r, showProposal, onChange }: { r: Response; showProposal?: boolean; onChange: () => void }) => {
  const [busy, setBusy] = useState(false);
  const k = KIND[r.kind];
  const toggle = async () => {
    setBusy(true);
    await api(`/api/admin/responses/${r.id}/handled`, { body: { handled: !r.handledAt } }).catch(() => undefined);
    setBusy(false);
    onChange();
  };
  return (
    <article className="req" data-kind={r.kind} data-done={!!r.handledAt || undefined}>
      <header>
        <span className="req-k">
          <Icon name={k.icon} />
          {k.label}
        </span>
        <span className="dim small">{fmtDateTime(r.createdAt)}</span>
      </header>
      <p className="req-who">
        <strong>{r.name ?? r.email}</strong>
        {r.name && <span className="dim"> · {r.email}</span>}
        {showProposal && r.proposalId && (
          <>
            {' '}
            em <Link to={`/admin/propostas/${r.proposalId}`}>{r.title}</Link>
          </>
        )}
      </p>
      {r.section && <p className="dim small">Lendo: {r.section}</p>}
      {r.slots?.length > 0 && (
        <ul className="req-slots">
          {r.slots.map((s, i) => (
            <li key={i}>{fmtSlot(s)}</li>
          ))}
          {r.mode && <li className="dim">{r.mode === 'presencial' ? 'Presencial' : 'Online'}</li>}
        </ul>
      )}
      {r.message && <blockquote>{r.message}</blockquote>}
      <button className="btn-link small" onClick={toggle} disabled={busy}>
        {r.handledAt ? 'Reabrir' : 'Marcar como resolvido'}
      </button>
    </article>
  );
};
